export default __webpack_public_path__ + "74ae18ebe4e79d9e549e79099dba040a.png";